import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Search/SearchResults/searchResults.default"
    ).then((module) => ({ default: module.SearchResultsDefault }))
);
